// utils/formatDateAndTime.ts

export const formatDate = (dateAndTimeString: string | undefined | null, locale = 'en-GB') => {
  if (!dateAndTimeString) return null;
  try {
    const date = new Date(dateAndTimeString);
    if (isNaN(date.getTime())) {
      return null;
    }
    return date.toLocaleDateString(locale, { day: '2-digit', month: 'long', year: 'numeric' });
  } catch {
    // Return undefined on error
  }
};

export const formatTime = (dateAndTimeString: string | undefined | null, locale = 'en-GB') => {
  if (!dateAndTimeString) return null;
  try {
    const date = new Date(dateAndTimeString);
    if (isNaN(date.getTime())) {
      return null;
    }
    return date
      .toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit', hour12: true })
      .toUpperCase();
  } catch {
    // Return undefined on error
  }
};

export default { formatDate, formatTime };
